import { EuiLink } from "@elastic/eui";
import React from "react";
import _ from "lodash";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";

const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        sortable: true,
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        width: 70,
    },
    {
        field: "contracted",
        name: "Contracted",
        sortable: true,
    },
    {
        field: "operationModule",
        name: "Operation Module",
        render: (item) => <span>{_.startCase(item)}</span>,
        sortable: true,
    },
    {
        field: "signDate",
        name: "Sign Date",
        dataType: "date",
        sortable: true,
    },
    {
        field: "endDate",
        name: "End Date",
        dataType: "date",
        sortable: true,
    },
    {
        field: "createdAt",
        name: "Creation Date",
        dataType: "date",
        sortable: true,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];

export default columns;
